
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6CcyL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $87c671b428db84cc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $87c671b428db84cc$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Desenvolvido pelo Atlassian Intelligence',
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Impulsionado pelo AI',
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "O conte\xfado \xe9 baseado nas permiss\xf5es e a qualidade pode variar",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': "A qualidade do conte\xfado pode variar",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "Utiliza a intelig\xeancia artificial Verifique os resultados.",
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': "Informa\xe7\xf5es",
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': "Inclua conhecimento da p\xe1gina atual",
    'fabric.editor.ai.commandPalette.promptForm.logo': 'Logotipo da Atlassian Intelligence',
    'fabric.editor.ai.components.backIconButton.backLabel': 'Voltar',
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancelar',
    'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancelar',
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancelar',
    'fabric.editor.ai.components.feedbackForm.badResponse': 'Resposta ruim',
    'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback enviado',
    'fabric.editor.ai.components.feedbackForm.goodResponse': 'Boa resposta',
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Continuar a partir da \xfaltima resposta",
    'fabric.editor.ai.config.item.action.copyResponse': 'Copiar',
    'fabric.editor.ai.config.item.action.responseCopied': 'Copiado!',
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': "Copiado para a \xe1rea de transfer\xeancia",
    'fabric.editor.ai.config.item.action.retryPrompt': 'Tentar de novo',
    'fabric.editor.ai.experience-application.documentInsertError': "A gente est\xe1 com problemas para inserir a resposta. Feche a caixa de di\xe1logo e tente de novo.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "N\xe3o foi poss\xedvel obter uma resposta. A solicita\xe7\xe3o ou resposta estava acima do limite dessa solicita\xe7\xe3o. Feche a caixa de di\xe1logo e tente de novo.",
    'fabric.editor.ai.experience.apiError': "N\xe3o foi poss\xedvel obter uma resposta. Tente de novo.",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.inputTooShortError': "O conte\xfado \xe9 curto demais para ser resumido. Adicione mais e tente de novo.",
    'fabric.editor.ai.experience.loadingAriaTitle': 'Gerando',
    'fabric.editor.ai.experience.previewScreenLabel': "Pr\xe9-visualizar",
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': "Diga ao agente algo para escrever ou escolha uma das op\xe7\xf5es abaixo",
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logotipo do Rovo',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': 'Voltar',
    'fabric.editor.ai.screens.discard.discardLabel': 'Descartar',
    'fabric.editor.ai.screens.error.warningIconLabel': 'Aviso',
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Erro',
    'fabric.editor.ai.screens.error.cancelLabel': 'Cancelar',
    'fabric.editor.ai.screens.error.retryLabel': 'Tentar de novo',
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': "Conte\xfado de atualiza\xe7\xe3o ao vivo:",
    'fabric.editor.ai.screens.loading.iconAltText': "\xcdcone de gera\xe7\xe3o",
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': "A\xe7\xf5es para conte\xfados gerados por IA",
    'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
    'fabric.editor.ai.screens.preview.cancelLabel': 'Cancelar',
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Diga ao AI o que fazer a seguir',
    'fabric.editor.ai.screens.preview.discardLabel': 'Descartar',
    'fabric.editor.ai.screens.preview.disclaimer': "A qualidade das informa\xe7\xf5es pode variar.",
    'fabric.editor.ai.screens.preview.disclaimerLink': 'Saiba por que',
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Limpar',
    'fabric.editor.ai.screens.preview.header.edit': 'Editar prompt',
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Editar',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Pergunte a {agentName} o que fazer a seguir',
    'fabric.editor.ai.screens.preview.refineButton': 'Refinar',
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Refinar',
    'fabric.editor.ai.screens.prompt.logoAltText': 'Logotipo da Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': 'Enviar',
    'fabric.editor.ai.screens.prompt.submitTooltip': 'Enviar para o AI',
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} selecionado',
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Remover',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': "Sugest\xf5es",
    'fabric.editor.ai.shared.aiUniversalDescriptor': "Assistente de reda\xe7\xe3o",
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': "Deixe o Atlassian Intelligence ajudar voc\xea a escrever",
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Escrever',
    'fabric.editor.ai.shared.betaLabel': 'Beta',
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
    'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVIDADE',
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Diga ao AI:',
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Diga ao agente'
};

});


//# sourceMappingURL=pt_BR.a536ef5e.js.map
